import React from 'react'

export function Mobile(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024" {...props}><path fill="currentColor" d="M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z"></path><path fill="currentColor" fillOpacity=".15" d="M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40s-40-17.9-40-40s17.9-40 40-40z"></path><path fill="currentColor" d="M472 786a40 40 0 1 0 80 0a40 40 0 1 0-80 0z"></path></svg>
  )
}
export default Mobile